cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storeoutlist_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			viewmodel.on("afterInit", function() {
				//仓库过滤条件只显示该门店仓库
				var storeid = cb.rest.AppContext.user.storeId;
				var proxy = cb.rest.DynamicProxy.create({
				  	settle: {
				  		url: "/bill/ref/getWarehousesFromStore",
				  		method: "POST" 
				  	} 
			 	});
			  	var params = {
				    storeId: storeid,
			  	};
			  	proxy.settle(params, (err, result) => {
			      	if (err) {
				        cb.utils.alert(err.message, 'error');
				        return;
			      	}
			
			      	if(result === undefined) {
			    	    cb.utils.alert("查询到门店仓库为空！", 'error');
			      	} else {
				      	//添加门店过滤条件只有周边门店
				      	var conditionWarehouse = {
				      		"isExtend": true,
									simpleVOs: []
				      	};
								conditionWarehouse.simpleVOs.push({
									field: 'id',
									op: 'in',
									value1: result
								});
				      	viewmodel.get('outWarehouse.name').getFromModel().setFilter(conditionWarehouse);
			      	}
		    	});
			});
		}

	}
	try {
		module.exports = ST_st_storeoutlist_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_storeoutlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storeoutlist_filterVM.Extend.js